import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TweenMax, TimelineMax } from 'gsap';
import styled from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OverviewPc from '@/components/PowerOcean/EcoFlowApp/Overview';
import OverViewH5 from '@/componentsH5/PowerOcean/EcoFlowApp/Overview';
import ScrollMagicFn from '@/utils/ScrollMagic';
import SEOlinksA from '@/components/SEOlinksA';

export default function PowerOceanApp({ SEO }: any) {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    const { isMobile, useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();
    const Overview = isMobile ? OverViewH5 : OverviewPc;
    const themeColor = 'black';

    return (
        <PageLayout isNoFixed={true} className={`${styled.PowerOceanApp}`} theme={'black'} style={{ backgroundColor: themeColor }}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['eu', 'de', 'uk']} locale={locale} pathname={'solutions/home-battery/PowerOcean/EcoFlow-App'} />
            <Overview />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = ['eu', 'de', 'uk'];
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
